import { render, staticRenderFns } from "./popPronunciationAdd.vue?vue&type=template&id=7aff400c&"
import script from "./popPronunciationAdd.vue?vue&type=script&lang=js&"
export * from "./popPronunciationAdd.vue?vue&type=script&lang=js&"
import style0 from "./popPronunciationAdd.vue?vue&type=style&index=0&id=7aff400c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports